// extracted by mini-css-extract-plugin
export default {"aiButton":"AiButton_aiButton__drhMA","aiButtonMain":"AiButton_aiButtonMain__0H1Rf","rotate":"AiButton_rotate__vS8TI","aiButtonBeta":"AiButton_aiButtonBeta__JFRgI"};